import React, { useState } from "react";
import {
  Col,
  Form,
  Row,
  Checkbox,
  Modal,
  Collapse,
  Table,
  Avatar,
  Divider,
  ConfigProvider,
  Popover,
} from "antd";
import { color } from "../../../../resource";
import Text from "../../../../components/Text/Text";
import Input from "../../../../components/Input/Input";
import {
  DeleteOutlined,
  DownOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import image from "../../../../resource/image";
import icon from "../../../../resource/icon";
import Button from "../../../../components/Button/Button";
import {
  CampaignProgramCondition,
  campaignProgramConditionLabel,
  CampaignProgramType,
  campaignProgramTypeLabel,
} from "../../../../definitions/campaign";
import {
  AddingContainer,
  CollapseContainer,
  ProgramTabsContainer,
  TabBody,
} from "../ProgramComponents";
import Select from "../../../../components/Select/Select";
import { ModalSelectStore } from "../../../Shared/ModalSelectStore";
import { FlexCol, FlexRow } from "../../../../components/Container/Container";
import { zoneDatasource } from "../../../../datasource/ZoneDatasource";
import { useEffectOnce } from "react-use";
import { onInputNumberKeyPress } from "../../../../utility/validator";
import { ModalSelectedProduct } from "../../../Shared/ModalSelecteProduct";
import {
  getProductBrand,
  getProductCategory,
  getProductGroup,
} from "../../../../datasource/ProductDatasource";

export const StepTwoDup = ({ form1, form2 }: { form1: any; form2: any }) => {
  const [modalForm] = Form.useForm();
  const dataForm2 = form2.getFieldsValue(true);
  const watchCampaignPrograms = Form.useWatch("campaignPrograms", form2);
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const [conditionOptions, setConditionOptions] = useState<any[]>([]);
  const [showModalCreate, setModalCreate] = useState(false);
  const [showModalStore, setShowModalStore] = useState<{ open: boolean; index: number }>({
    open: false,
    index: -1,
  });
  const [showModalProduct, setShowModalProduct] = useState<{ open: boolean; index: number }>({
    open: false,
    index: -1,
  });
  const [showModalSameCampaignPoint, setShowModalSameCampaignPoint] = useState(false);
  const [zone, setZone] = useState<any[]>([]);
  const [activeTabs, setActiveTabs] = useState<Record<number, "shop" | "product">>({});
  const [modalDelete, setModalDelete] = useState({ open: false, index: -1, name: "" });
  const [keyActive, setKeyActive] = useState<any>(["0"]);
  const [productGroups, setProductGroups] = useState<any>();

  const getZoneByCompany = async () => {
    const res = await zoneDatasource.getAllZoneByCompany(company);
    const data = res.map((item: any) => {
      return {
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      };
    });
    setZone(data);
  };
  const getProductGroupList = async () => {
    await getProductGroup(company).then((res) => {
      setProductGroups(res.responseData);
    });
  };

  useEffectOnce(() => {
    getZoneByCompany();
    getProductGroupList();
  });

  const toggleModalCreate = () => {
    setModalCreate(!showModalCreate);
    setConditionOptions(
      form1.getFieldValue("campaignProgramType") === CampaignProgramType.ONLY_DEALER
        ? company === "ICPL"
          ? [CampaignProgramCondition.CONFIRM_RECEIVED]
          : [CampaignProgramCondition.DELIVERY_SUCCESS]
        : [CampaignProgramCondition.SUBMIT_DELIVERY_DOC],
    );
    modalForm.resetFields();
  };

  const onDeleteProgram = (index: number) => {
    const programs = form2.getFieldValue("campaignPrograms") || [];
    programs.splice(index, 1);
    form2.setFieldsValue({ campaignPrograms: programs });
  };

  return (
    <>
      <Form form={form2} layout='vertical'>
        <Row align='middle' gutter={16} style={{ marginBottom: "16px" }}>
          <Col span={16}>
            <Form.Item
              name='campaignPrograms'
              rules={[{ required: true, message: "โปรดเพิ่มโปรแกรมอย่างน้อย 1 รายการ" }]}
            >
              <Text level={2} fontWeight={700}>
                รายการพอยท์โปรแกรม
              </Text>
            </Form.Item>
          </Col>
          {dataForm2.campaignPrograms?.length > 0 && (
            <>
              <Col span={4}>
                <Button
                  title='เพิ่มเงื่อนไขเดียวกัน'
                  typeButton={
                    watchCampaignPrograms?.some((program: any) => program.isChecked)
                      ? "primary-light"
                      : "border-light"
                  }
                  onClick={() => setShowModalSameCampaignPoint(true)}
                  size='large'
                  disabled={!watchCampaignPrograms?.some((program: any) => program.isChecked)}
                />
              </Col>
              <Col span={4}>
                <Button
                  title='เพิ่มพอยท์โปรแกรม'
                  typeButton='primary'
                  icon={<PlusOutlined />}
                  onClick={toggleModalCreate}
                  size='large'
                />
              </Col>
            </>
          )}
        </Row>
        {dataForm2.campaignPrograms?.length <= 0 ? (
          <AddingContainer onClick={toggleModalCreate} style={{ background: "white" }}>
            <img src={icon.addPointProgram} style={{ width: "80px" }} />
            <br />
            <Text level={4} color='primary'>
              <PlusOutlined />
              &nbsp;เพิ่มพอยท์โปรแกรม
            </Text>
            <Text level={5}>โปรดเพิ่มพอยท์โปรแกรมสำหรับแคมเปญ</Text>
            <Text level={5}>และต่อด้วยการเพิ่มร้านค้า, สินค้า และแต้มตามลำดับ</Text>
          </AddingContainer>
        ) : (
          dataForm2.campaignPrograms?.map((program: any, index: number) => {
            const isActive = activeTabs[index] ?? "shop";
            return (
              <>
                <CollapseContainer key={index}>
                  <Collapse
                    activeKey={keyActive}
                    onChange={(key: any) => {
                      setKeyActive(key);
                    }}
                    collapsible='icon'
                    expandIconPosition='end'
                    expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
                  >
                    <Collapse.Panel
                      key={index}
                      header={
                        <Row key={index} align='middle'>
                          <Col span={1} style={{ paddingTop: "20px" }}>
                            <Form.Item
                              name={["campaignPrograms", index, "isChecked"]}
                              valuePropName='checked'
                            >
                              <Checkbox />
                            </Form.Item>
                          </Col>
                          <Col span={7}>
                            <Form.Item
                              label='ชื่อพอยท์โปรแกรม'
                              name={["campaignPrograms", index, "campaignProgramName"]}
                              rules={[{ required: true, message: "*โปรดระบุชื่อพอยท์โปรแกรม" }]}
                            >
                              <Input style={{ width: "80%" }} />
                            </Form.Item>
                          </Col>
                          <Col span={4} style={{ paddingBottom: "24px" }}>
                            <Text color='Text3' level={6}>
                              รูปแบบการให้แต้ม
                            </Text>
                            <br />
                            <Text color='Text1' level={5} fontWeight={700}>
                              {campaignProgramTypeLabel[form1.getFieldValue("campaignProgramType")]}
                            </Text>
                          </Col>
                          <Col span={4} style={{ paddingBottom: "24px" }}>
                            <Text color='Text3' level={6}>
                              เงื่อนไขการได้รับแต้ม
                            </Text>
                            <br />
                            <Text color='Text1' level={5} fontWeight={700}>
                              {campaignProgramConditionLabel[program.campaignProgramCondition]}
                            </Text>
                          </Col>
                          <Col span={8}>
                            <Row gutter={16}>
                              <Col span={10}>
                                <Form.Item
                                  name={["campaignPrograms", index, "campaignProgramDealers"]}
                                  rules={[{ required: true, message: "โปรดเพิ่มร้านค้า" }]}
                                >
                                  <Button
                                    title='เพิ่มร้านค้า'
                                    icon={<PlusCircleOutlined />}
                                    typeButton='primary-light'
                                    onClick={() => {
                                      setShowModalStore({ open: true, index: index });
                                      setActiveTabs((prev) => ({
                                        ...prev,
                                        [index]: "shop",
                                      }));
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={10}>
                                <Form.Item
                                  name={["campaignPrograms", index, "campaignProgramProducts"]}
                                  rules={[{ required: true, message: "โปรดเพิ่มสินค้า" }]}
                                >
                                  <Button
                                    title='เพิ่มสินค้า'
                                    icon={<PlusCircleOutlined />}
                                    typeButton='primary-light'
                                    onClick={() => {
                                      setShowModalProduct({ open: true, index: index });
                                      setActiveTabs((prev) => ({
                                        ...prev,
                                        [index]: "product",
                                      }));
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Button
                                  icon={<DeleteOutlined style={{ color: color.error }} />}
                                  typeButton='border-danger'
                                  onClick={() =>
                                    setModalDelete({
                                      open: true,
                                      index: index,
                                      name: form2.getFieldValue([
                                        "campaignPrograms",
                                        index,
                                        "campaignProgramName",
                                      ]),
                                    })
                                  }
                                  style={{ padding: "8px 0px", width: 40 }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                    >
                      <ProgramTabsContainer style={{ background: color.background4 }}>
                        <Row gutter={4}>
                          <Col span={12}>
                            <FlexRow
                              onClick={() => {
                                setActiveTabs((prev) => ({
                                  ...prev,
                                  [index]: "shop",
                                }));
                              }}
                              align='center'
                              justify='center'
                              style={{
                                backgroundColor: isActive === "shop" ? "white" : "#F5F7FA",
                                width: "100%",
                                height: 58,
                                borderRadius: "6px 6px 0px 0px",
                                cursor: "pointer",
                              }}
                            >
                              <Text
                                level={3}
                                color={isActive === "shop" ? "primary" : "Text3"}
                                fontWeight={isActive === "shop" ? 700 : 400}
                              >
                                ร้านค้า (
                                {form2.getFieldValue([
                                  "campaignPrograms",
                                  index,
                                  "campaignProgramDealers",
                                ])?.length || 0}
                                )
                              </Text>
                            </FlexRow>
                          </Col>
                          <Col span={12}>
                            <FlexRow
                              onClick={() => {
                                setActiveTabs((prev) => ({
                                  ...prev,
                                  [index]: "product",
                                }));
                              }}
                              align='center'
                              justify='center'
                              style={{
                                backgroundColor: isActive === "product" ? "white" : "#F5F7FA",
                                width: "100%",
                                height: 58,
                                borderRadius: "6px 6px 0px 0px",
                                cursor: "pointer",
                              }}
                            >
                              <Text
                                level={3}
                                color={isActive === "product" ? "primary" : "Text3"}
                                fontWeight={isActive === "product" ? 700 : 400}
                              >
                                สินค้า (
                                {form2.getFieldValue([
                                  "campaignPrograms",
                                  index,
                                  "campaignProgramProducts",
                                ])?.length || 0}
                                )
                              </Text>
                            </FlexRow>
                          </Col>
                        </Row>
                        <TabBody>
                          {isActive === "shop" ? (
                            <ShopTab
                              form2={form2}
                              zoneList={zone}
                              index={index}
                              customerType={form1.getFieldValue("campaignProgramType")}
                            />
                          ) : (
                            <ProductTab form2={form2} index={index} company={company} />
                          )}
                        </TabBody>
                      </ProgramTabsContainer>
                    </Collapse.Panel>
                  </Collapse>
                </CollapseContainer>
                <br />
              </>
            );
          })
        )}
      </Form>
      {modalDelete.open && (
        <Modal
          open={modalDelete.open}
          onCancel={() => setModalDelete({ open: false, index: -1, name: "" })}
          onOk={() => {
            onDeleteProgram(modalDelete.index);
            setModalDelete({ open: false, index: -1, name: "" });
          }}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          centered
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
          title={
            <Text level={2} fontWeight={700}>
              ยืนยันการลบพอยต์โปรแกรม?
            </Text>
          }
        >
          <Text level={2} fontWeight={700}>
            {`"${modalDelete.name}"`}
          </Text>
          <br />
          <Text color='Text3'>โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน</Text>
          <Divider size='small' />
        </Modal>
      )}
      {showModalCreate && (
        <ModalCreateCampaignPoint
          showModal={showModalCreate}
          toggleModal={toggleModalCreate}
          modalForm={modalForm}
          conditionOptions={conditionOptions}
          onSubmit={async () => {
            try {
              await modalForm.validateFields();
              const dataModalForm = {
                ...modalForm.getFieldsValue(),
                campaignProgramDealers: [],
                campaignProgramProducts: [],
                isChecked: false,
              };
              form2.setFieldsValue({
                campaignPrograms: [...(dataForm2.campaignPrograms || []), dataModalForm],
              });
              setKeyActive((prev) => [
                ...prev,
                form2.getFieldValue("campaignPrograms")?.length - 1 || 0,
              ]);
              setActiveTabs((prev) => ({
                ...prev,
                [form2.getFieldValue("campaignPrograms")?.length - 1]: "shop",
              }));
              toggleModalCreate();
            } catch (error) {
              console.error(error);
            }
          }}
        />
      )}
      {showModalStore.open && (
        <ModalSelectStore
          callBackShop={(shop) => {
            const dataForm2 = form2.getFieldsValue(true);
            form2.setFieldsValue({
              campaignPrograms: dataForm2.campaignPrograms.map((program, idx) =>
                idx === showModalStore.index
                  ? {
                      ...program,
                      campaignProgramDealers: [
                        ...(program.campaignProgramDealers || []),
                        ...shop.map((s) => ({ ...s, isChecked: false })),
                      ],
                      searchDealer: [
                        ...(program.campaignProgramDealers || []),
                        ...shop.map((s) => ({ ...s, isChecked: false })),
                      ],
                    }
                  : program,
              ),
            });
            setKeyActive((prev) => [...prev, showModalStore.index]);
            setActiveTabs((prev) => ({
              ...prev,
              [showModalStore.index]: "shop",
            }));
            setShowModalStore({ open: false, index: -1 });
          }}
          showModalShop={showModalStore.open}
          currentSelectShop={
            form2
              .getFieldValue("campaignPrograms")
              ?.map((program) => program.campaignProgramDealers)
              .flat() || []
          }
          company={company}
          onClose={() => setShowModalStore({ open: false, index: -1 })}
          customerType={
            form1.getFieldValue("campaignProgramType") === "ONLY_SUB_DEALER" ? "SD" : "DL"
          }
        />
      )}
      {showModalProduct.open && (
        <ModalSelectedProduct
          company={company}
          showModalProd={showModalProduct.open}
          onClose={() => setShowModalProduct({ open: false, index: -1 })}
          productGroup={productGroups || []}
          isDisable={true}
          callBackProduct={(product) => {
            const dataForm2 =
              form2.getFieldsValue(true).campaignPrograms?.[showModalProduct.index] || {};
            const mapChecked = product.map((p) => ({
              ...p,
              isChecked: false,
              [`programPoints-${p.productId}`]: undefined,
            }));
            form2.setFieldValue(
              ["campaignPrograms", showModalProduct.index, "campaignProgramProducts"],
              [...(dataForm2.campaignProgramProducts || []), ...mapChecked],
            );
            form2.setFieldValue(
              ["campaignPrograms", showModalProduct.index, "searchProduct"],
              [...(dataForm2.searchProduct || []), ...mapChecked],
            );
            setKeyActive((prev) => [...prev, showModalStore.index]);
            setActiveTabs((prev) => ({
              ...prev,
              [showModalStore.index]: "product",
            }));
            setShowModalProduct({ open: false, index: -1 });
          }}
          prodSelected={
            form2.getFieldValue([
              "campaignPrograms",
              showModalProduct.index,
              "campaignProgramProducts",
            ]) || []
          }
        />
      )}
      {showModalSameCampaignPoint && (
        <ModalSameCampaignPoint
          showModal={showModalSameCampaignPoint}
          setShowModal={setShowModalSameCampaignPoint}
          productGroups={productGroups || []}
          company={company}
          campaignProgramType={form1.getFieldValue("campaignProgramType")}
          onSubmit={(data) => {
            const formData2 = form2.getFieldsValue(true);
            const mapData = formData2.campaignPrograms?.map((program, index) => {
              if (!program.isChecked) return program;
              setActiveTabs((prev) => ({
                ...prev,
                [index]: "product",
              }));
              setKeyActive((prev) => [...prev, index || 0]);
              return {
                ...program,
                campaignProgramProducts: data,
                searchProduct: data,
                isChecked: false,
              };
            });
            form2.setFieldValue("campaignPrograms", mapData);
            setShowModalSameCampaignPoint(false);
          }}
        />
      )}
    </>
  );
};

const ModalCreateCampaignPoint = ({
  showModal,
  toggleModal,
  modalForm,
  conditionOptions,
  onSubmit,
}: any) => {
  return (
    <Modal
      centered
      maskClosable={false}
      open={showModal}
      onCancel={toggleModal}
      footer={
        <Row justify='end' gutter={16}>
          <Col span={6}>
            <Button typeButton='primary-light' title='ยกเลิก' onClick={toggleModal} />
          </Col>
          <Col span={6}>
            <Button type='primary' title='บันทึก' onClick={onSubmit} />
          </Col>
        </Row>
      }
    >
      <Text level={4} fontWeight={700}>
        เพิ่มพอยท์โปรแกรม
      </Text>
      <br />
      <Form form={modalForm} layout='vertical'>
        <Form.Item
          label='ชื่อพอยท์โปรแกรม'
          name='campaignProgramName'
          rules={[{ required: true, message: "โปรดชื่อระบุพอยท์โปรแกรม" }]}
        >
          <Input autoComplete='off' placeholder='ชื่อพอยท์โปรแกรม' />
        </Form.Item>
        <Form.Item
          label='เงื่อนไขการได้รับแต้ม'
          name='campaignProgramCondition'
          rules={[{ required: true, message: "โปรดเลือกเงื่อนไขการได้รับแต้ม" }]}
        >
          <Select
            data={conditionOptions?.map((t) => ({
              label: campaignProgramConditionLabel[t],
              value: t,
              key: t,
            }))}
          />
        </Form.Item>
      </Form>
      <Divider />
    </Modal>
  );
};

const ShopTab = ({
  form2,
  zoneList,
  index,
  customerType,
}: {
  form2: any;
  zoneList: any[];
  index: number;
  customerType: string;
}) => {
  const dataForm2 = form2.getFieldValue("campaignPrograms")?.[index] || {};
  const watchCampaignProgramDealers =
    Form.useWatch(["campaignPrograms", index, "campaignProgramDealers"], form2) || [];
  const watchSearchDealer = Form.useWatch(["campaignPrograms", index, "searchDealer"], form2) || [];
  const [searchZone, setSearchZone] = useState<any>(undefined);
  const [searchText, setSearchText] = useState<any>(undefined);
  const [modalDelete, setModalDelete] = useState<boolean>(false);

  const onSearch = (text: string, zone: string) => {
    const searchDealer = form2.getFieldsValue(true).campaignPrograms[index].campaignProgramDealers;
    form2.setFieldValue(
      ["campaignPrograms", index, "searchDealer"],
      searchDealer.filter((dealer: any) => {
        const cusMatch = text
          ? dealer.customerName.includes(text) || dealer.customerNo.includes(text)
          : true;
        const zoneMatch = zone ? `${dealer.zone}` === `${zone}` : true;
        return cusMatch && zoneMatch;
      }),
    );
  };

  const onDelete = () => {
    const dataForm2 =
      form2.getFieldsValue(true).campaignPrograms?.[index].campaignProgramDealers || [];
    const newData = dataForm2.filter((dealer: any) => !dealer.isChecked);
    form2.setFieldValue(["campaignPrograms", index, "campaignProgramDealers"], newData);
    form2.setFieldValue(["campaignPrograms", index, "searchDealer"], newData);
  };

  const columns = [
    {
      title: (
        <Checkbox
          disabled={!watchSearchDealer.length}
          checked={watchSearchDealer.length && watchSearchDealer?.every((s) => s.isChecked)}
          onClick={(e: any) => {
            const checked = e.target.checked;
            const dealerList = dataForm2.campaignProgramDealers;
            const searchDealer = dataForm2.searchDealer;
            const mapShop = dealerList.map((dealer: any) => {
              const map = searchDealer.find(
                (s: any) => `${s.customerCompanyId}` === `${dealer.customerCompanyId}`,
              );
              return {
                ...dealer,
                isChecked: map ? checked : dealer.isChecked,
              };
            });
            form2.setFieldValue(["campaignPrograms", index, "campaignProgramDealers"], mapShop);
            form2.setFieldValue(["campaignPrograms", index, "searchDealer"], mapShop);
            onSearch(searchText, searchZone);
          }}
        />
      ),
      width: "5%",
      dataIndex: "isChecked",
      render: (value: any, row: any, i: number) => {
        return (
          <Checkbox
            checked={value}
            onClick={(e: any) => {
              const checked = e.target.checked;
              form2.setFieldValue(
                ["campaignPrograms", index, "campaignProgramDealers"],
                dataForm2.campaignProgramDealers.map((dealer: any) =>
                  dealer.customerCompanyId === row.customerCompanyId
                    ? { ...dealer, isChecked: checked }
                    : dealer,
                ),
              );
              form2.setFieldValue(
                ["campaignPrograms", index, "searchDealer"],
                dataForm2.campaignProgramDealers.map((dealer: any) =>
                  dealer.customerCompanyId === row.customerCompanyId
                    ? { ...dealer, isChecked: checked }
                    : dealer,
                ),
              );
              onSearch(searchText, searchZone);
            }}
          />
        );
      },
    },
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, i: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "40%",
      render: (value: any, row: any, i: number) => {
        return {
          children: (
            <>
              <Text>{value}</Text>
              <br />
              <Text level={6} color='Text3'>
                {row?.customer?.taxNo}
              </Text>
            </>
          ),
        };
      },
    },
    {
      title: "ประเภทคู่ค้า",
      dataIndex: "partner",
      key: "partner",
      render: (value: any, row: any, i: number) => {
        return {
          children: (
            <Text level={6}>
              {customerType === CampaignProgramType.ONLY_DEALER ? "Dealer" : "Subdealer"}
            </Text>
          ),
        };
      },
    },
    {
      title: "เขตการขาย",
      dataIndex: "zone",
      key: "zone",
      render: (value: any, row: any, i: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
  ];

  return (
    <>
      <Row justify='start' gutter={16}>
        <Col span={8}>
          <Input
            allowClear
            style={{ width: "100%" }}
            placeholder='รหัส / ชื่อร้านค้า'
            suffix={<SearchOutlined />}
            onChange={(e) => {
              if (e.target.value) {
                setSearchText(e.target.value);
                onSearch(e.target.value, searchZone);
              } else {
                setSearchText("");
                onSearch("", searchZone);
              }
            }}
          />
        </Col>
        <Col span={4}>
          <Select
            style={{ width: "100%" }}
            placeholder='เลือกเขต'
            data={zoneList || []}
            onChange={(value) => {
              if (!value) {
                setSearchZone(undefined);
                onSearch(searchText, "");
                return;
              } else {
                setSearchZone(value);
                onSearch(searchText, value);
              }
            }}
          />
        </Col>
        <Col span={9} />
        <Col span={3}>
          <Form.Item name={["campaignPrograms", index, "campaignProgramDealers"]}>
            <Button
              typeButton={
                watchCampaignProgramDealers?.some((s) => s.isChecked) ? "danger" : "disabled"
              }
              icon={
                <DeleteOutlined
                  style={{
                    color: "white",
                  }}
                />
              }
              title={`ลบร้านค้า (${watchCampaignProgramDealers?.filter((s) => s.isChecked).length})`}
              disabled={!watchCampaignProgramDealers?.some((s) => s.isChecked)}
              onClick={() => {
                setModalDelete(true);
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <br />
      <Form.Item name={["campaignPrograms", index, "searchDealer"]}>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                headerColor: "#FFFFFF",
              },
            },
          }}
        >
          <Table
            columns={columns}
            dataSource={form2?.getFieldValue(["campaignPrograms", index, "searchDealer"]) || []}
            pagination={false}
            size='small'
            scroll={{ y: "550px" }}
          />
        </ConfigProvider>
      </Form.Item>
      {modalDelete && (
        <Modal
          open={modalDelete}
          onCancel={() => setModalDelete(false)}
          onOk={() => {
            onDelete();
            onSearch(searchText, searchZone);
            setModalDelete(false);
          }}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          centered
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
          title={
            <Text level={2} fontWeight={700}>
              ยืนยันการลบร้านค้า?
            </Text>
          }
        >
          <Text color='Text3'>โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน</Text>
          <Divider size='small' />
        </Modal>
      )}
    </>
  );
};

const ProductTab = ({ form2, index, company }: { form2: any; index: number; company: string }) => {
  const dataForm2 = form2.getFieldValue("campaignPrograms")?.[index] || {};
  const watchSearchProduct = Form.useWatch(["campaignPrograms", index, "searchProduct"], form2);
  const watchCampaignProgramProducts = Form.useWatch(
    ["campaignPrograms", index, "campaignProgramProducts"],
    form2,
  );

  const [searchText, setSearchText] = useState<any>(undefined);
  const [modalSameCondition, setModalSameCondition] = useState(false);
  const [modalDelete, setModalDelete] = useState<boolean>(false);

  const onSearch = (text: string) => {
    const searchProduct =
      form2.getFieldsValue(true).campaignPrograms[index].campaignProgramProducts;
    form2.setFieldValue(
      ["campaignPrograms", index, "searchProduct"],
      searchProduct.filter((product: any) => {
        const proMatch = text
          ? product.productName?.toLowerCase().includes(text) ||
            product.productCodeNAV?.toLowerCase().includes(text)
          : true;
        return proMatch;
      }),
    );
  };

  const onDelete = () => {
    const newProduct = dataForm2.campaignProgramProducts.filter(
      (product: any) => !product.isChecked,
    );
    form2.setFieldValue(["campaignPrograms", index, "campaignProgramProducts"], newProduct);
    form2.setFieldValue(["campaignPrograms", index, "searchProduct"], newProduct);
    onSearch(searchText);
  };

  const columns = [
    {
      title: (
        <Checkbox
          disabled={!watchSearchProduct?.length}
          checked={watchSearchProduct?.length && watchSearchProduct?.every((s: any) => s.isChecked)}
          onClick={(e: any) => {
            const checked = e.target.checked;
            form2.setFieldValue(
              ["campaignPrograms", index, "campaignProgramProducts"],
              dataForm2.campaignProgramProducts.map((product: any) => ({
                ...product,
                isChecked: checked,
              })),
            );
            form2.setFieldValue(
              ["campaignPrograms", index, "searchProduct"],
              dataForm2.searchProduct.map((product: any) => ({
                ...product,
                isChecked: checked,
              })),
            );
            onSearch(searchText);
          }}
        />
      ),
      width: "3%",
      key: "isChecked",
      dataIndex: "isChecked",
      render: (value: any, row: any) => {
        return (
          <Checkbox
            checked={value}
            onClick={(e: any) => {
              const checked = e.target.checked;
              form2.setFieldValue(
                ["campaignPrograms", index, "campaignProgramProducts"],
                dataForm2.campaignProgramProducts.map((product: any) => {
                  return {
                    ...product,
                    isChecked:
                      `${product.productId}` === `${row.productId}` ? checked : product.isChecked,
                  };
                }),
              );
              form2.setFieldValue(
                ["campaignPrograms", index, "searchProduct"],
                dataForm2.searchProduct.map((product: any) => {
                  return {
                    ...product,
                    isChecked:
                      `${product.productId}` === `${row.productId}` ? checked : product.isChecked,
                  };
                }),
              );
              onSearch(searchText);
            }}
          />
        );
      },
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "name",
      key: "productName",
      width: "35%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row gutter={8} style={{ padding: "12px 0px" }} align='middle'>
              <Col>
                <Avatar
                  src={row.productImage ? row.productImage : image.product_no_image}
                  size={70}
                  shape='square'
                  onError={() => false}
                />
              </Col>
              <Col>
                <Text>
                  {row.productName}
                  <br />
                </Text>
                {row.commonName && row.commonName.length > 0 && (
                  <>
                    <Text level={6}>
                      {row.commonName.length > 35
                        ? row.commonName.slice(0, 35) + "..."
                        : row.commonName}
                    </Text>
                    <br />
                  </>
                )}
                <Text level={6} color='Text3'>
                  Product Group : {row.productGroup || "-"}
                </Text>
                {company === "ICPL" && (
                  <>
                    <br />
                    <Text level={6} color='Text3'>
                      Stragery Group : {row.productStrategy || "-"}
                    </Text>
                  </>
                )}
              </Col>
            </Row>
          ),
        };
      },
    },
    {
      dataIndex: "packSize",
      render: (value: any, row: any) => {
        return (
          <FlexCol>
            <Text>{value}</Text>
            <Text color='Text3'>{row.productCodeNAV}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "แต้มที่ได้รับ",
      dataIndex: "productId",
      key: "productId",
      width: "40%",
      render: (productId: any, row: any, i: number) => {
        return (
          <Row gutter={16} align='middle'>
            <Col span={17}>
              <Text level={5}>
                <img src={icon.star} style={{ width: "16px" }} />
                &nbsp;แต้มที่ได้รับ
              </Text>
              <Form.Item
                name={[
                  "campaignPrograms",
                  index,
                  "searchProduct",
                  i,
                  `programPoints-${row.productId}`,
                ]}
                rules={[{ required: true, message: "กรุณากรอกแต้ม" }]}
              >
                <Input
                  autoComplete='off'
                  suffix={<Text level={5}>แต้ม</Text>}
                  onKeyDown={onInputNumberKeyPress}
                  onChange={(e) => {
                    const value = e.target.value;
                    form2.setFieldsValue({
                      campaignPrograms: form2
                        .getFieldValue("campaignPrograms")
                        .map((cp: any, ci: number) => {
                          if (ci === index) {
                            return {
                              ...cp,
                              campaignProgramProducts: cp.campaignProgramProducts.map(
                                (cpp: any, cpi: number) => {
                                  const find = row.productId === cpp.productId;
                                  if (find) {
                                    return {
                                      ...cpp,
                                      [`programPoints-${row.productId}`]: value ? value : undefined,
                                    };
                                  }
                                  return cpp;
                                },
                              ),
                            };
                          }
                          return cp;
                        }),
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Text level={5}>ต่อหน่วย SKU</Text>
              <Form.Item>
                <Input disabled value={row.saleUOMTH || ""} style={{ color: color.BK }} />
              </Form.Item>
            </Col>
            {/* <Col span={5} style={{ borderLeft: "1px solid #E5EAEE" }}>
              <Button
                style={{ width: 40, height: 40 }}
                typeButton='border-light'
                icon={<EditOutlined style={{ color: color.primary }} />}
                // onClick={() => setReplace([i, productId])}
              />
            </Col> */}
          </Row>
        );
      },
    },
  ];

  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Input
            allowClear
            placeholder='รหัส / ชื่อสินค้า'
            suffix={<SearchOutlined />}
            autoComplete='off'
            onChange={(e) => {
              if (e.target.value) {
                setSearchText(e.target.value);
                onSearch(e.target.value);
              } else {
                setSearchText("");
                onSearch("");
              }
            }}
          />
        </Col>
        <Col span={9} />
        <Col span={4}>
          <Button
            typeButton={
              watchCampaignProgramProducts?.some((s) => s.isChecked)
                ? "primary-light"
                : "border-light"
            }
            title='ตั้งค่าแต้มเดียวกันทุกสินค้า'
            onClick={() => {
              setModalSameCondition(true);
              form2.setFieldsValue({
                sameConditionPoint: undefined,
              });
            }}
            disabled={!watchCampaignProgramProducts?.some((s) => s.isChecked)}
          />
        </Col>
        <Col span={3}>
          <Form.Item name={["campaignPrograms", index, "campaignProgramProducts"]}>
            <Button
              title={`ลบสินค้า (${watchCampaignProgramProducts?.filter((s) => s.isChecked).length || 0})`}
              typeButton={
                watchCampaignProgramProducts?.some((s) => s.isChecked) ? "danger" : "disabled"
              }
              icon={
                <DeleteOutlined
                  style={{
                    color: "white",
                  }}
                />
              }
              disabled={!watchCampaignProgramProducts?.some((s) => s.isChecked)}
              onClick={() => setModalDelete(true)}
            />
          </Form.Item>
        </Col>
      </Row>
      <br />
      <Form.Item name={["campaignPrograms", index, "searchProduct"]}>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                headerColor: "#FFFFFF",
              },
            },
          }}
        >
          <Table
            columns={columns}
            dataSource={form2.getFieldValue(["campaignPrograms", index, "searchProduct"]) || []}
            scroll={{ y: 600 }}
            pagination={false}
            size='small'
          />
        </ConfigProvider>
      </Form.Item>
      {modalDelete && (
        <Modal
          open={modalDelete}
          onCancel={() => setModalDelete(false)}
          onOk={() => {
            onDelete();
            onSearch(searchText);
            setModalDelete(false);
          }}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          centered
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
          title={
            <Text level={2} fontWeight={700}>
              ยืนยันการลบสินค้า?
            </Text>
          }
        >
          <Text color='Text3'>โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน</Text>
          <Divider size='small' />
        </Modal>
      )}
      {modalSameCondition && (
        <ModalCreateSamePointProgram
          modalSameCondition={modalSameCondition}
          setModalSameCondition={setModalSameCondition}
          onSubmit={(value) => {
            setModalSameCondition(false);
            const dataMap = form2.getFieldValue([
              "campaignPrograms",
              index,
              "campaignProgramProducts",
            ]);
            form2.setFieldValue(
              ["campaignPrograms", index, "campaignProgramProducts"],
              dataMap.map((item: any) => {
                return item.isChecked
                  ? {
                      ...item,
                      [`programPoints-${item.productId}`]: value,
                      isChecked: false,
                    }
                  : item;
              }),
            );
            form2.setFieldValue(
              ["campaignPrograms", index, "searchProduct"],
              dataMap.map((item: any) => {
                return item.isChecked
                  ? {
                      ...item,
                      [`programPoints-${item.productId}`]: value,
                      isChecked: false,
                    }
                  : item;
              }),
            );
            onSearch(searchText);
          }}
        />
      )}
    </>
  );
};

const ModalCreateSamePointProgram = ({
  modalSameCondition,
  setModalSameCondition,
  onSubmit,
}: any) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={modalSameCondition}
      closable={true}
      onCancel={() => setModalSameCondition(false)}
      centered
      footer={null}
      width={500}
      maskClosable={false}
    >
      <Form form={form} layout='vertical'>
        <Text level={3} fontWeight={700}>
          ตั้งค่าแต้มเดียวกันทุกสินค้า
        </Text>
        <Form.Item
          label='แต้มที่ได้รับทุกสินค้า'
          name='sameConditionPoint'
          rules={[{ required: true, message: "โปรดระบุจำนวนแต้ม" }]}
        >
          <Input autoComplete='off' placeholder='ระบุจำนวนแต้ม' onKeyDown={onInputNumberKeyPress} />
        </Form.Item>
        <Divider size='small' />
        <Row justify='end'>
          <Col>
            <Button
              typeButton='primary'
              title='บันทึก'
              onClick={() => {
                form.validateFields().then((value) => {
                  onSubmit(value.sameConditionPoint);
                });
              }}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ModalSameCampaignPoint = ({
  showModal,
  setShowModal,
  onSubmit,
  campaignProgramType,
  company,
  productGroups,
}: {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  onSubmit: (data: any) => void;
  campaignProgramType: string;
  company: string;
  productGroups?: any[];
}) => {
  const [sameForm] = Form.useForm();
  const [step, setStep] = useState(1);

  const renderStep = () => {
    switch (step) {
      case 0: {
        return (
          <ModalSelectStore
            //replaceSaveButtonTitle={step === 0 ? "ถัดไป" : "บันทึก"}
            callBackShop={(shop) => {
              setStep(1);
            }}
            showModalShop={showModal}
            currentSelectShop={[]}
            company={company}
            onClose={() => setShowModal(false)}
            customerType={campaignProgramType === "ONLY_SUB_DEALER" ? "SD" : "DL"}
          />
        );
      }
      case 1: {
        return (
          <ModalSelectedProduct
            company={company}
            showModalProd={showModal}
            onClose={() => setShowModal(false)}
            productGroup={productGroups || []}
            isDisable={true}
            callBackProduct={(product) => {
              if (
                (product && product.length > 0) ||
                sameForm?.getFieldValue("products")?.length > 0
              ) {
                const dataForm = sameForm.getFieldsValue(true) || [];
                const newProduct = product.map((p: any) => ({
                  ...p,
                  [`programPoints-${p.productId}`]: undefined,
                  isChecked: false,
                }));
                sameForm.setFieldsValue({
                  products: dataForm.products
                    ? [...dataForm.products, ...newProduct]
                    : [...newProduct],
                  searchProduct: dataForm.products
                    ? [...dataForm.products, ...newProduct]
                    : [...newProduct],
                });
                setStep(2);
              } else {
                setShowModal(false);
              }
            }}
            prodSelected={sameForm.getFieldValue("products") || []}
          />
        );
      }
      case 2: {
        return (
          <Form form={sameForm}>
            <ModalPointProgram
              showModalPoint={showModal}
              setShowModalPoint={setShowModal}
              productGroup={productGroups || []}
              form={sameForm}
              company={company}
              onClose={() => setStep(1)}
              onSubmit={async () => {
                try {
                  await sameForm.validateFields().then(() => {
                    const formData = sameForm.getFieldsValue(true);
                    onSubmit(formData.products);
                  });
                } catch (error) {
                  console.error("Validation failed:", error);
                }
              }}
            />
          </Form>
        );
      }
    }
  };

  return <>{renderStep()}</>;
};

const ModalPointProgram = ({
  showModalPoint,
  setShowModalPoint,
  form,
  company,
  onClose,
  onSubmit,
  productGroup,
}: any) => {
  const dataForm = form.getFieldsValue(true);
  const [strategyGroup, setStrategyGroup] = useState([]);
  const [brand, setBrand] = useState([]);
  const watchProducts = Form.useWatch("searchProduct", form);
  const [modalSameCondition, setModalSameCondition] = useState(false);
  const [searchSection, setSearchSection] = useState<{
    text?: string;
    proGroup?: string;
    category?: string;
    brand?: string;
  }>({ text: undefined, proGroup: undefined, category: undefined, brand: undefined });

  const fetchCatetory = async () => {
    const getCatetory = await getProductCategory(company).then((res) => {
      return res;
    });
    setStrategyGroup(getCatetory);
  };
  const fetchBrand = async () => {
    const getBrand = await getProductBrand(company).then((res) => {
      return res;
    });
    setBrand(getBrand);
  };

  useEffectOnce(() => {
    fetchCatetory();
    fetchBrand();
  });

  const onSearch = (text?: string, proGroup?: string, category?: string, brand?: string) => {
    const filteredProducts = form.getFieldValue("products").filter((p: any) => {
      const searchText = text
        ? p.productName.toLowerCase().includes(text.toLowerCase()) ||
          p.productCodeNAV?.toLowerCase().includes(text.toLowerCase())
        : true;
      const searchProGroup = proGroup ? p.productGroup === proGroup : true;
      const searchCategory = category ? p.productStrategy === category : true;
      const searchBrand = brand ? p.productBrandId === brand : true;
      return searchText && searchProGroup && searchCategory && searchBrand;
    });
    form.setFieldsValue({ searchProduct: filteredProducts });
  };

  const onDelete = (productId: string) => {
    const products = form.getFieldValue("products") || [];
    const updatedProducts = products.filter((p: any) => p.productId !== productId);
    form.setFieldsValue({ products: updatedProducts, searchProduct: updatedProducts });
  };

  const columns = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "name",
      key: "productName",
      width: "35%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row gutter={8} style={{ padding: "12px 0px" }} align='middle'>
              <Col>
                <Avatar
                  src={row.productImage ? row.productImage : image.product_no_image}
                  size={70}
                  shape='square'
                  onError={() => false}
                />
              </Col>
              <Col>
                {row.productName.length > 50 ? (
                  <Popover
                    color={color.BK}
                    title={
                      <Text color='white' level={6}>
                        {row.productName}
                      </Text>
                    }
                  >
                    <Text style={{ cursor: "pointer" }}>
                      {row.productName.slice(0, 35) + "..."}
                    </Text>
                  </Popover>
                ) : (
                  <Text>{row.productName}</Text>
                )}
                <br />
                {row.commonName && (
                  <>
                    <Text level={6}>
                      {row.commonName.length > 50
                        ? row.commonName.slice(0, 50) + "..."
                        : row.commonName}
                    </Text>
                  </>
                )}
                <Text level={6} color='Text3'>
                  Product Group : {row.productGroup || "-"}
                </Text>
                {company === "ICPL" && (
                  <>
                    <br />
                    <Text level={6} color='Text3'>
                      Stragery Group : {row.productStrategy || "-"}
                    </Text>
                  </>
                )}
              </Col>
            </Row>
          ),
        };
      },
    },
    {
      dataIndex: "packSize",
      render: (value: any, row: any) => {
        return (
          <FlexCol>
            <Text>{value}</Text>
            <Text color='Text3'>{row.productCodeNAV}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "แต้มที่ได้รับ",
      dataIndex: "productId",
      key: "productId",
      width: "42%",
      render: (productId: any, row: any, i: number) => {
        return (
          <Row gutter={16} align='middle'>
            <Col span={12}>
              <Text level={5}>
                <img src={icon.star} style={{ width: "16px" }} />
                &nbsp;แต้มที่ได้รับ
              </Text>
              <Form.Item
                name={["searchProduct", i, `programPoints-${productId}`]}
                rules={[{ required: true, message: "กรุณากรอกแต้ม" }]}
              >
                <Input
                  suffix={<Text level={5}>แต้ม</Text>}
                  onKeyDown={onInputNumberKeyPress}
                  autoComplete='off'
                  onChange={(e) => {
                    const value = e.target.value;
                    form.setFieldsValue({
                      products: form.getFieldValue("searchProduct").map((cp: any, ci: number) => {
                        if (cp.productId === productId) {
                          return {
                            ...cp,
                            [`programPoints-${productId}`]: value ? value : undefined,
                          };
                        }
                        return cp;
                      }),
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Text level={5}>ต่อหน่วย SKU</Text>
              <Form.Item>
                <Input disabled value={row.saleUOMTH || ""} style={{ color: color.BK }} />
              </Form.Item>
            </Col>
            <Col span={5} style={{ borderLeft: "1px solid #E5EAEE" }}>
              <Button
                style={{ width: 40, height: 40 }}
                typeButton='border-light'
                icon={<DeleteOutlined style={{ color: color.error }} />}
                onClick={() => onDelete(productId)}
              />
            </Col>
          </Row>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        centered
        maskClosable={false}
        open={showModalPoint}
        onCancel={() => setShowModalPoint(false)}
        footer={null}
        width={1350}
      >
        <Text level={4} fontWeight={700}>
          เพิ่มพอยท์โปรแกรม
        </Text>
        <Row gutter={16} justify='start'>
          <Col span={9}>
            <Form.Item label='ค้นหาสินค้า'>
              <Input
                value={searchSection.text}
                placeholder='รหัส / ชื่อสินค้า'
                suffix={<SearchOutlined />}
                style={{ width: "100%" }}
                onPressEnter={(e: any) =>
                  onSearch(
                    e.target.value,
                    searchSection.proGroup,
                    searchSection.category,
                    searchSection.brand,
                  )
                }
                onChange={(e) => {
                  setSearchSection({ ...searchSection, text: e.target.value });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label='Product Group'>
              <Select
                value={searchSection.proGroup}
                data={productGroup.map((p: any) => ({
                  key: p.product_group,
                  value: p.product_group,
                  label: p.product_group,
                }))}
                onChange={(e) => {
                  setSearchSection({ ...searchSection, proGroup: e });
                  onSearch(searchSection.text, e, searchSection.category, searchSection.brand);
                }}
                placeholder='ทั้งหมด'
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {company === "ICPL" && (
            <Col span={4}>
              <Form.Item label='Strategy Group'>
                <Select
                  value={searchSection.category}
                  data={strategyGroup.map((p: any) => ({
                    key: p.productCategoryId,
                    value: p.productCategoryId,
                    label: p.productCategoryName,
                  }))}
                  onChange={(e) => {
                    setSearchSection({ ...searchSection, category: e });
                    onSearch(searchSection.text, searchSection.proGroup, e, searchSection.brand);
                  }}
                  placeholder='ทั้งหมด'
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          )}
          {brand?.length && (
            <Col span={4}>
              <Form.Item label='ยี่ห้อ'>
                <Select
                  value={searchSection.brand}
                  data={brand.map((p: any) => ({
                    key: p.productBrandId,
                    value: p.productBrandId,
                    label: p.productBrandName,
                  }))}
                  onChange={(e) => {
                    setSearchSection({ ...searchSection, brand: e });
                    onSearch(searchSection.text, searchSection.proGroup, searchSection.category, e);
                  }}
                  placeholder='ทั้งหมด'
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={3} style={{ paddingTop: "32px" }}>
            <Button
              title='ล้างการค้นหา'
              typeButton='primary-light'
              onClick={() => {
                setSearchSection({
                  text: undefined,
                  proGroup: undefined,
                  category: undefined,
                  brand: undefined,
                });
                form.setFieldsValue({ searchProduct: dataForm.products });
              }}
            />
          </Col>
        </Row>
        <Row justify='end' style={{ padding: "10px" }}>
          <Col span={4}>
            <Button
              typeButton='primary-light'
              title='ตั้งค่าแต้มเดียวกันทุกสินค้า'
              onClick={() => {
                setModalSameCondition(true);
                form.setFieldsValue({
                  sameConditionPoint: undefined,
                });
              }}
            />
          </Col>
        </Row>
        <Form.Item name='searchProduct'>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  headerColor: "#FFFFFF",
                },
              },
            }}
          >
            <Table
              columns={columns}
              dataSource={form.getFieldValue("searchProduct") || []}
              scroll={{ y: 400 }}
              pagination={false}
              size='small'
            />
          </ConfigProvider>
        </Form.Item>
        <Divider />
        <Row justify='space-between'>
          <Col>
            <Button
              title='ย้อนกลับ'
              typeButton='primary-light'
              style={{ width: 136, marginRight: 8 }}
              onClick={() => onClose()}
            />
          </Col>
          <Col>
            <Button title={"บันทึก"} style={{ width: 136 }} onClick={onSubmit} />
          </Col>
        </Row>
      </Modal>
      {modalSameCondition && (
        <ModalCreateSamePointProgram
          modalSameCondition={modalSameCondition}
          setModalSameCondition={setModalSameCondition}
          onSubmit={(value) => {
            const dataForm = form.getFieldsValue(true) || [];
            const mapData =
              dataForm.products.map((item: any) => ({
                ...item,
                [`programPoints-${item.productId}`]: value,
              })) || [];
            form.setFieldsValue({
              products: mapData,
              searchProduct: mapData,
            });
            setModalSameCondition(false);
            onSearch(
              searchSection.text,
              searchSection.proGroup,
              searchSection.category,
              searchSection.brand,
            );
          }}
        />
      )}
    </>
  );
};
